import { render, staticRenderFns } from "./QHImgopen.vue?vue&type=template&id=4cc35116"
import script from "./QHImgopen.vue?vue&type=script&lang=js"
export * from "./QHImgopen.vue?vue&type=script&lang=js"
import style0 from "./QHImgopen.vue?vue&type=style&index=0&id=4cc35116&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports